<template>
  <section id="about">
    <h2>ABOUT THE FILM</h2>
    <p>We follow 8 storylines through a dystopian world set in the Summer of 2020. The link between each story is a genocide that has reached a critical point. To make things worse, a global pandemic has swept the world & particularly America, which is ruled by “The Supremacy”. Curfews have been implemented on sections of the populus. The capital “Metropolice”, is under siege - sirens, helicopters, & fireworks are the soundtrack to the revolution. The narrative thread is the genocide, the protagonist & antagonist is: The American Holocaust.
    </p>
  </section>
</template>

<script>
export default {
  name: 'About',
  mounted() {
    window.setInterval(() => {
      const about = document.querySelector('#about')
      about.style.filter = "invert(1)"

      window.setTimeout(() => about.style.filter = "invert(0)", 700)
      window.setTimeout(() => about.style.filter = "invert(1)", 790)
      window.setTimeout(() => about.style.filter = "invert(0)", 950)
    }, 7000)
  }
}
</script>

<style scoped lang="scss">
#about {
  // filter: contrast(0.5);
  padding: {
    left: 20px;
    right: 20px;
  } 
  background: {
    image: url('../assets/propaganda-blue.svg');
    size: 50%;
    repeat: round;
  }
  color: black;

  h2 {
    padding: 5px 20px;    
    display: inline-block;
    margin: {
      left: auto;
      right: auto;
    }
    color: #c61e3a;
  }

  p {
    font-size: 12px;
    line-height: 1.1;
    max-width: 768px;
    margin: 0 auto;
    font-weight: bold;
    padding: 20px;
    line-height: 1.5;
    background-color: rgb(205 186 173 / 75%);
    box-shadow: inset 4px 4px 1px #c61e3a;
    border-bottom: 4px solid black;
    border-right: 4px solid black;
  }
}

@media screen and (min-width: 768px) {
  #about {
    padding: {
      left: 50px;
      right: 50px;
    }
    background: {
      image: 
        url('../assets/propaganda-blue.svg'),
        url('../assets/propaganda-red.svg'),
        url('../assets/propaganda-gray.svg'),
        url('../assets/propaganda-blue.svg'),
        url('../assets/propaganda-red.svg'),
        url('../assets/propaganda-gray.svg');
      size: auto 53%;
      position: 
        top left, 
        top center,
        top right,
        bottom left,
        bottom center,
        bottom right;
      repeat: no-repeat;
    }

    p {
      font-size: 18px;
    }
  }
}

@media screen and (min-width: 1280px) {
  #about {
    background: {
      size: contain;
      repeat: space;
    }
  }
}
</style>